import styled from '@emotion/styled';
import { tokens, Typography } from '@sunrun/experience-ui-components';

const ListViewCellText = styled(Typography)<{ $warning?: boolean }>`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-word;
  text-align: left;
  color: ${({ $warning }) =>
    $warning ? tokens.ERROR_50 : tokens.BRAND_HEROBLUE};
`;

export { ListViewCellText };
